export default __webpack_public_path__ + "static/media/LineProtofoilo.967630e8.jpg";